class productCalculator extends HTMLElement {
  constructor() {
    super();

    // Tabs logic
    const tabs = document.querySelectorAll('.custom_product_tabs .tabs .item');
    tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
            if (!tab.classList.contains('active')) {
              const tabContentItem =  document.querySelectorAll('.custom_product_tabs .content .item');
              tabContentItem.forEach((contentItem) => {
                    contentItem.classList.remove('active');
                });
                tabs.forEach((tabItem) => {
                    tabItem.classList.remove('active');
                });
                const tabId = tab.dataset.tab;
                tab.classList.add('active');
                document.querySelector(`.custom_product_tabs .content #${tabId}`).classList.add('active');
            }
        });
    });

    // product & variants containers and product form
    this.productContainer = document.querySelector('[data-product-wrapper]');
    this.variantsContainer = document.querySelector('variant-radios');
    this.productForm = this.productContainer.querySelector('product-form');

    // input radios and its labels
    this.radioLabels = this.querySelectorAll('[data-sort-tegels] label');
    this.radioInputs = this.querySelectorAll('[data-sort-tegels] input[type=radio]');
    this.cuttingLoss = this.querySelector('input[name=cutting_loss]');
    // hidden quantity input from Product form
    this.cartQuantityInput = this.productForm.querySelector('input[name=quantity]');
    // input text quantities for titles, m2 and mxm
    this.inputTiles = this.querySelector('input[name=quantity_tiles]');
    this.inputSquareMeters = this.querySelector('input[name=quantity_squaremeters]');
    this.inputMeters1 = this.querySelector('input[name=quantity_meters_value_1]');
    this.inputMeters2 = this.querySelector('input[name=quantity_meters_value_2]');

    // calculated final amount & price elements
    this.calculatedAmount = this.querySelector('[data-calculated-amount]');
    this.calculatedPrice = this.querySelector('[data-calculated-price]');

    this.productPrice = this.querySelector('[data-calculator-price]');

    // calculation variables and initial values
    this.calculationType = 'tiles'; // tiles, m2, mxm
    this.calculationTiles = 0;
    this.calculationSquareMeters = 0;
    this.calculationMeters1 = 0;
    this.calculationMeters2 = 0;
    this.tileWidth = parseInt(this.querySelector('input[name=calculator_tilewidth]').value);
    this.tileHeight = parseInt(this.querySelector('input[name=calculator_tileheight]').value);
    this.calculateCuttingLoss = this.cuttingLoss.checked;

    this.init();

  }

  init() {

    // Check if we have a quantity block, if so, we can hide it since the quantity from the calculator is being used
    const cartQuantityRow = this.productContainer.querySelector('.product-form__quantity');
    if (cartQuantityRow) {
      cartQuantityRow.style.display = "none";
    }

    // Bind on clicks on the radio buttons
    this.radioInputs.forEach(radioInput => radioInput.addEventListener('click', (e) => {
      this.calculationType = e.currentTarget.value;
      this.checkState();
    }));

    // Bind a change event on the quantity input itself
    this.cartQuantityInput.addEventListener('keyup', (e) => {
      this.calculationTiles = Math.ceil(this.checkNumber(e.target.value, this.calculationTiles));
      this.calculationType = 'tiles';
      this.inputTiles.value = this.calculationTiles;
      this.checkState();
    });

    // Bind on keyup on the inputs
    this.inputTiles.addEventListener('keyup', (e) => this.handleInputTilesChange(e));
    this.inputSquareMeters.addEventListener('keyup', (e) => this.handleInputSquareMetersChange(e));
    this.inputMeters1.addEventListener('keyup', (e) => this.handleInputMeters1Change(e));
    this.inputMeters2.addEventListener('keyup', (e) => this.handleInputMeters2Change(e));

    // Bind on change on the inputs
    this.inputTiles.addEventListener('change', (e) => this.handleInputTilesChange(e));
    this.inputSquareMeters.addEventListener('change', (e) => this.handleInputSquareMetersChange(e));
    this.inputMeters1.addEventListener('change', (e) => this.handleInputMeters1Change(e));
    this.inputMeters2.addEventListener('change', (e) => this.handleInputMeters2Change(e));

    // Bind on focus on the inputs
    this.inputTiles.addEventListener('focus', (e) => this.handleInputTilesChange(e));
    this.inputSquareMeters.addEventListener('focus', (e) => this.handleInputSquareMetersChange(e));
    this.inputMeters1.addEventListener('focus', (e) => this.handleInputMeters1Change(e));
    this.inputMeters2.addEventListener('focus', (e) => this.handleInputMeters2Change(e));

    // On (variant) change of the price recalculate
    this.variantsContainer?.addEventListener('change', (e) => {
      // Give the change some time to process
      setTimeout(() => {
        this.calculate();
      }, 100);
    });

    // Bind the on change on the cutting loss selector
    this.cuttingLoss.addEventListener('change', (e) => {
      this.calculateCuttingLoss = this.cuttingLoss.checked;
      this.checkState();
    });

    this.checkState();

  }

  /**
   * Handle Input changes - on Keyup, Change & Focus
   */

  handleInputTilesChange(e) {
    if (e.type != 'focus') this.calculationTiles = Math.ceil(this.checkNumber(e.target.value, this.calculationTiles));
    this.calculationType = 'tiles';
    this.checkState();
  }
  handleInputSquareMetersChange(e) {
    if (e.type != 'focus') {
      let newVal = e.target.value.replace('.', ',');
      this.calculationSquareMeters = this.checkNumber(newVal, this.calculationSquareMeters);
    }
    this.calculationType = 'm2';
    this.checkState();
  }
  handleInputMeters1Change(e) {
    if (e.type != 'focus') this.calculationMeters1 = this.checkNumber(e.target.value, this.calculationMeters1);
    this.calculationType = 'mxm';
    this.checkState();
  }
  handleInputMeters2Change(e) {
    if (e.type != 'focus') this.calculationMeters2 = this.checkNumber(e.target.value, this.calculationMeters2);
    this.calculationType = 'mxm';
    this.checkState();
  }

  /**
   * Calculate the final price
   */

  calculate() {

    // Get initial variables and values
    let calculatedAmount = 0;
    let productSquareSize = this.tileWidth * this.tileHeight / 10000; // Reduce back to cm
    let productPrice = this.productPrice.innerHTML;
    let newAmount;

    // See which state we are in, make the calculation depending on this
    switch(this.calculationType) {
      case 'tiles':
        this.calculationSquareMeters = '';
        this.calculationMeters1 = '';
        this.calculationMeters2 = '';
        calculatedAmount = this.calculationTiles;

        this.inputSquareMeters.value = '';
        this.inputMeters1.value = '';
        this.inputMeters2.value = '';
        break;
      case 'm2':
        this.calculationMeters1 = '';
        this.calculationMeters2 = '';
        newAmount = Math.ceil(this.calculationSquareMeters / productSquareSize);
        if (!isNaN(newAmount)) {
          calculatedAmount = newAmount;
          this.calculationTiles = newAmount;
        }

        this.inputTiles.value = this.calculationTiles != 0 ? this.calculationTiles : '';
        this.inputMeters1.value = '';
        this.inputMeters2.value = '';
        break;
      case 'mxm':
        this.calculationSquareMeters = parseFloat(this.calculationMeters1 * this.calculationMeters2).toFixed(2);
        newAmount = Math.ceil(this.calculationSquareMeters / productSquareSize);
        if (!isNaN(newAmount)) {
          calculatedAmount = newAmount;
          this.calculationTiles = newAmount;
        }

        this.inputTiles.value = this.calculationTiles != 0 ? this.calculationTiles : '';
        this.inputSquareMeters.value = this.calculationSquareMeters != 0 ? this.calculationSquareMeters : '';
        break;
    }

    // Check if we need to calculate the cutting loss
    if (this.calculateCuttingLoss) calculatedAmount = Math.ceil(calculatedAmount * 1.099);

    // set the right quantity on the hidden input
    this.cartQuantityInput.value = calculatedAmount == 0 ? '' : calculatedAmount;
    // update values on the calculator - set the calculated amount & price
    this.calculatedAmount.innerHTML = calculatedAmount;
    this.calculatedPrice.innerHTML = formatMoney(calculatedAmount * productPrice, '{{amount_with_comma_separator}}');

  }

  /**
   * Check number
   */

  checkNumber(number, oldValue) {
    let newValue = Math.abs(parseFloat(number.replace(',', '.')));
    if (number == '') return 0;
    if (!isNaN(newValue)) return newValue;
    return oldValue;
  }

  /**
   * Check state and update the class checked accordingly
   */

  checkState() {

    this.radioLabels.forEach(radioLabel => radioLabel.classList.remove('checked'));

    this.radioInputs.forEach(radioInput => {
      this.parentLabel = radioInput.closest('label');
      if (radioInput.value == this.calculationType) this.parentLabel.classList.add('checked');
    });

    this.calculate();
  }

}

if(!customElements.get('product-calculator')) {
  customElements.define('product-calculator', productCalculator);
}
